import { Button } from '@toggle/design-system';
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorRobot from './cache-error.svg';
import styles from './CacheError.module.scss';

interface CacheErrorProps {
  onClick?: () => void;
  className?: string;
}

export const CacheError = ({
  onClick = () => window.location.reload(),
  className,
}: CacheErrorProps) => {
  const { t } = useTranslation('error');

  return (
    <section
      data-testid="cache-error-view"
      className={classnames(styles.section, className)}
    >
      <ErrorRobot alt={t('error:notFound.pageText')} viewBox="0 0 74 70" />
      <p className={styles.message}>{t('error:cacheError.message')}</p>
      <Button
        data-testid="cache-error-view-btn"
        label={t('error:cacheError.reload')}
        onClick={onClick}
        variant="secondary"
      />
    </section>
  );
};
